import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'src/components/queryProvider';
import { queryKeys, requestCCApi } from 'src/utils';

export const useDeleteAssemblyTag = () => {
  return useMutation({
    mutationFn: deleteAssemblyTag,
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeys.assemblyTags.invalidateAll());
      queryClient.invalidateQueries(
        queryKeys.viewAssemblyTagsWithAssembliesCount.invalidateAll(),
      );
    },
  });
};

const deleteAssemblyTag = async (tagId: number) => {
  const response = await requestCCApi({
    url: `/assemblyTags/${tagId}`,
    method: 'DELETE',
  });

  return response;
};
